export default __webpack_public_path__ + "static/media/cat3-2.f11131e2.jpg";